import React, { Fragment } from "react";
import { Tree, Tooltip } from "antd";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./HierarchyTree.css";
import {  Droppable, Draggable } from "@hello-pangea/dnd";

// const TreeNode = Tree.TreeNode;

const HierarchyTree = (props) => {
	const {
		isLoaded,
		treeData,
		selectNode,
		updateHierarchy,
		mergeMode,
		draggable,
		showServices,
		showTags,
		showBuildSources,
	} = props;

	const getListStyle = (isDraggingOver) => ({
		// background: isDraggingOver ? "white" : "white",
		// padding: grid,
		// width: 250,
	});

	const getItemStyle = (isDragging, draggableStyle) => ({
		// some basic styles to make the items look a bit nicer
		// userSelect: "none",
		// padding: grid * 2,
		// paddingLeft: 8,
		
		// paddingBottom: 2,
		// margin: `0 0 ${grid}px 0`,
		// fontWeight: 600,
	
		// change background colour if dragging
		// background: isDragging ? "lightgreen" : "grey",
	
		// styles we need to apply on draggables
		...draggableStyle,
		lineHeight: 1.5,
	});

	const HierarchyTreeNodeTags = (nodeData) => {
		return (
			<Tooltip
				title={nodeData.description}
				color="hsl(var(--text))"
				placement="right"
			>
				<div title="" className="w-full">
					<Droppable droppableId={nodeData.title}>
						{(provided, snapshot) => (
							<div
								{...provided.droppableProps}
								ref={provided.innerRef}
								style={getListStyle(snapshot.isDraggingOver)}
								className=""
							>
								<span className="mr-10">{nodeData.title}</span>
								<span className="relative ">
									{showServices &&
										nodeData.services.map((service, index) => (
											<Draggable
												key={String(service.id)}
												draggableId={String(service.id)}
												index={index}
											>
												{(provided, snapshot) => (
													<span
														key={service.id}
														className="bg-primary-soft py-0 px-2 text-primary text-sm rounded-full mx-1 text-right"
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
														style={getItemStyle(
															snapshot.isDragging,
															provided.draggableProps.style
														)}
													>
														{service.name}
													</span>
												)}
											</Draggable>
										))}
									{showTags &&
										nodeData.tags.map((tag, index) => (
											<Draggable
												key={String(tag.id)}
												draggableId={String(tag.id)}
												index={index}
											>
												{(provided, snapshot) => (
													<span
														key={tag.id}
														className="bg-success-soft py-0 px-2 text-success text-sm rounded-full mx-1 text-right"
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
														style={getItemStyle(
															snapshot.isDragging,
															provided.draggableProps.style
														)}
													>
														{tag.key}:{tag.value}
													</span>
												)}
											</Draggable>
										))}
									{showBuildSources &&
										nodeData.build_sources.map((build_source, index) => (
											<Draggable
												key={String(build_source.id)}
												draggableId={String(build_source.id)}
												index={index}
											>
												{(provided, snapshot) => (
													<span
														key={build_source.id}
														className="bg-primary-soft py-0 px-2 text-primary text-sm rounded-full mx-1 text-right whitespace-nowrap"
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
														style={getItemStyle(
															snapshot.isDragging,
															provided.draggableProps.style
														)}
													>
														{build_source.build_source}
													</span>
												)}
											</Draggable>
										))}
										{provided.placeholder}
								</span>
								
							</div>
						)}
					</Droppable>
				</div>
			</Tooltip>
		);
	};

	const HierarchyTreeNode = (nodeData) => {
		return (
			<Tooltip
				title={nodeData.description}
				color="hsl(var(--text))"
				placement="right"
			>
				<div title="" className="w-full">
							<div
								className=""
							>
								<span className="mr-10">{nodeData.title}</span>
								<span className="relative">
									{showServices &&
										nodeData.services.map((service, index) => (
													<span
														key={service.id}
														className="bg-primary-soft py-0 px-2 text-primary rounded-full mx-1 text-right"
													>
														{service.name}
													</span>
										))}
								</span>
								
							</div>
				</div>
			</Tooltip>
		);
	};

	const onDragStart = (info) => {
		const blankCanvas = document.createElement("canvas");
		info.event.dataTransfer?.setDragImage(blankCanvas, 0, 0);
		document.body.appendChild(blankCanvas);
	};

	const onDragEnter = (info) => {
		// console.log(info);
		// expandedKeys 需要受控时设置
		// setExpandedKeys(info.expandedKeys)
	};

	const onDrop = (info) => {
		const dropKey = info.node.key;
		const dragKey = info.dragNode.key;
		const dropPos = info.node.pos.split("-");
		const dropPosition =
			info.dropPosition - Number(dropPos[dropPos.length - 1]);

		const loop = (data, key, callback) => {
			for (let i = 0; i < data.length; i++) {
				if (data[i].key === key) {
					return callback(data[i], i, data);
				}
				if (data[i].children) {
					loop(data[i].children, key, callback);
				}
			}
		};
		const data = treeData;
		// Find dragObject
		let dragObj;
		loop(data, dragKey, (item, index, arr) => {
			arr.splice(index, 1);
			dragObj = item;
		});

		if (!info.dropToGap) {
			// Drop on the content
			loop(data, dropKey, (item) => {
				item.children = item.children || [];
				// where to insert 示例添加到头部，可以是随意位置
				dragObj.tree_order = 0;
				item.children.unshift(dragObj);
				reindexTreeOrder(item.children);
			});
		} else if (
			(info.node.props.children || []).length > 0 &&
			// Has children
			info.node.props.expanded &&
			// Is expanded
			dropPosition === 1 // On the bottom gap
		) {
			loop(data, dropKey, (item) => {
				item.children = item.children || [];
				// where to insert 示例添加到头部，可以是随意位置
				dragObj.tree_order = 0;
				item.children.unshift(dragObj);
				reindexTreeOrder(item.children);
				// in previous version, we use item.children.push(dragObj) to insert the
				// item to the tail of the children
			});
		} else {
			let ar = [];
			let i;
			loop(data, dropKey, (_item, index, arr) => {
				ar = arr;
				i = index;
			});
			if (dropPosition === -1) {
				dragObj.tree_order = i + 0.5;
				ar.splice(i, 0, dragObj);
			} else {
				dragObj.tree_order = i + 0.5;
				ar.splice(i + 1, 0, dragObj);
			}
			reindexTreeOrder(ar);
		}
		console.log(data);
		updateHierarchy(data);
	};

	function reindexTreeOrder(data) {
		for (let i = 0; i < data.length; i++) {
			data[i].tree_order = i + 1;
		}
	}

	function onSelect(node) {
		selectNode(node[0]);
	}

	if (isLoaded) {
		return (
			<Fragment>
				<Tree
					treeData={prepareTreeData(treeData)}
					className="p-10 pb-0"
					onSelect={onSelect}
					draggable={draggable}
					onDragEnter={onDragEnter}
					onDragStart={onDragStart}
					onDrop={onDrop}
					showLine={false}
					defaultExpandAll={true}
					titleRender={showServices || showTags || showBuildSources ? HierarchyTreeNodeTags : HierarchyTreeNode}
					autoExpandParent={true}
					selectedKeys={props.selectedKeys}
					rootClassName={mergeMode ? "merge" : "normal"}
				/>
			</Fragment>
		);
	} else {
		return <Fragment></Fragment>;
	}
};

export default HierarchyTree;

function prepareTreeData(data) {
	if (data.length > 0) {
		for (let i = 0; i < data.length; i++) {
			data[i].key = data[i].id;
			data[i].title = data[i].name;

			if (data[i].children !== undefined) {
				prepareTreeData(data[i].children);

				// sort the children on name
				data[i].children.sort(compare);
			}
		}
	}

	return data;
}

function compare(a, b) {
	if (a.tree_order < b.tree_order) {
		return -1;
	}
	if (a.tree_order > b.tree_order) {
		return 1;
	}
	return 0;
}
